<template>
  <div>
    <b-form @submit.prevent="save">
      <b-card v-if="carregado">

        <lg-form-input description=" " disabled v-model="form.registroEntrada.tipoAquisicao.descricao"
          label="Tipo Aquisição:" cols="12" />
        <lg-form-input description=" " disabled v-model="form.naturezaDespesa" label="Natureza:" cols="12" />

        <lg-form-input description=" " disabled v-model="form.almoxarifadoDto.descricao" label="Almoxarifado:"
          cols="12" />


        <lg-form-input description=" " disabled v-model="form.registroEntrada.notaFiscal" label="Nota Fiscal:"
          cols="12" />
        <lg-form-input description=" " disabled v-model="form.registroEntrada.nroEmpenho" label="Nº Empenho:"
          cols="12" />
        <lg-form-input description=" " disabled v-model="form.numProcesso" label="Nº Processo:" cols="12" />
        <lg-form-input description=" " disabled v-model="form.numContrato" label="Nº Contrato:" cols="12" />

        <lg-form-input description=" " disabled
          :value="form.registroEntrada.fornecedor && form.registroEntrada.fornecedor.razaoSocial" label="Fornecedor"
          cols="12" />
        <lg-form-input description=" " disabled v-model="form.grupoProduto.descricao" label="Grupo:" cols="12" />

        <lg-form-input description=" " disabled v-model="form.subgrupoProduto.descricao" label="Subgrupo:" cols="12" />
        <lg-form-input description=" " disabled v-model="form.classe.descricao" label="Classe:" cols="12" />

      </b-card>
    </b-form>
  </div>
</template>
<script>

import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { integer } from "vuelidate/lib/validators";
import IBPService from "@/core/api/IBPService";

export default {
  components: {
    LgFormInput,
  },
  props: {
    id: integer,
  },
  data() {
    return {
      form: {
      },
      carregado: false,
    };
  },
  async beforeMount() {
    this.$service = new IBPService();
    if (this.id) {
      this.busy = true;
      let vm = this;
      this.$service.buscarRegistroEntradaView(this.id).then(response => {

        response.data.naturezaDespesa = response.data.naturezaDespesa.numeroFmt + ' - ' + response.data.naturezaDespesa.descricao;
        response.data.grupoProduto.descricao = response.data.grupoProduto.id + ' - ' + response.data.grupoProduto.descricao;
        response.data.subgrupoProduto.descricao = response.data.grupoProduto.id + "." + response.data.subgrupoProduto.id + ' - ' + response.data.subgrupoProduto.descricao;
        response.data.classe.descricao = response.data.grupoProduto.id + "." + response.data.subgrupoProduto.id + "." + response.data.classe.id + ' - ' + response.data.classe.descricao;


        vm.form = response.data;
        vm.carregado = true;

      });
    }
  },


  methods: {


  },
};
</script>
